import { render } from "./ClearButton.vue?vue&type=template&id=bc091d7e"
import script from "./ClearButton.vue?vue&type=script&lang=js"
export * from "./ClearButton.vue?vue&type=script&lang=js"
script.render = render

export default script